module.exports = __webpack_public_path__ + "img/logo31.7a038bbf.png";